import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import ScheduleOrder from "./ScheduleOrder";
import ScheduleGroupUser from "./ScheduleGroupUser";
import { useLocation } from "react-router-dom";

function Dashboard() {
  const Status = useSelector(
    (state) => state.statistics.ScheduleStatsToggleStatus
  );
  const location = useLocation();
  const { state } = location;
  const ID = state;

  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
          Schedule Order Details
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        <ToggleDetails />
        {Status === "General" ? <ScheduleOrder id={ID}/> : null}
        {Status === "Group/User" ? <ScheduleGroupUser id={ID}/> : null}
      </div>
    </>
  );
}

export default Dashboard;
